(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('xplr-size-finder')) {
  const seen = new Set();
  class XplrSizeFinder extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.openFilters);
      const key = location.pathname;
      if (!seen.has(key) && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            seen.add(key);
            this.querySelector('button')?.classList.add('is-arriving');
            this.observer.disconnect();
          }
        }, { threshold: 0.6 });
        this.observer.observe(this);
      }
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.openFilters);
      this.observer?.disconnect();
    }
    async openFilters() {
      const results = this.closest('results-list');
      const scope = results || this.closest('.shopify-section') || document;
      let form;
      if (matchMedia('(min-width: 1024px)').matches) {
        results?.setAttribute('show-filtering', 'true');
        form = scope.querySelector('.facet-filtering form');
      } else {
        await customElements.whenDefined('dialog-component');
        const drawer = scope.querySelector('#filters-drawer') || document.getElementById('filters-drawer');
        drawer?.showDialog();
        form = drawer?.querySelector('form');
      }
      requestAnimationFrame(() => requestAnimationFrame(() => {
        const field = form?.querySelector('input[name="filter.v.option.size"]');
        const details = field?.closest('details');
        const summary = details?.querySelector('summary');
        if (details && !details.open) summary?.click();
        summary?.focus({ preventScroll: true });
        summary?.scrollIntoView({ block: 'nearest', behavior: 'instant' });
      }));
    }
  }
  customElements.define('xplr-size-finder', XplrSizeFinder);
}
  } catch(e) { console.error(e); }
})();

})();
